import { Controller } from "stimulus";
import NotificationModule from "./shared_modules/notification_module.js";

export default class extends Controller {
  static targets = ["modal", "currentQc", "status", "userSelect", "dueDate", "stackLabel"];

  connect() {
    this.notifications = new NotificationModule(null);
    this.reassignUrl = null;
  }

  open(event) {
    if (event) event.preventDefault();
    this.openFromButton(event.currentTarget);
  }

  openFromButton(button) {
    if (!button) return;

    this.reassignUrl = button.dataset.url;
    this.currentQcUserId = button.dataset.currentQcUserId || "";
    this.stackLabelTarget.textContent = button.dataset.stackLabel || "Stack";
    this.currentQcTarget.textContent = button.dataset.currentQc || "Unassigned";
    this.statusTarget.textContent = button.dataset.qcStatus || "";
    this.userSelectTarget.value = this.currentQcUserId;
    if (this.hasDueDateTarget) {
      this.dueDateTarget.value = "";
    }

    this.modalTarget.classList.remove("hidden");
  }

  closeBackdrop(event) {
    if (event.target === this.modalTarget) {
      this.close();
    }
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  close(event) {
    if (event) event.preventDefault();
    this.modalTarget.classList.add("hidden");
  }

  submit(event) {
    event.preventDefault();

    const assignedTo = this.userSelectTarget.value;
    if (!assignedTo) {
      this.notifications.error("Please select a QC officer.");
      return;
    }

    const currentQcUserId = this.currentQcUserId;
    const selectedName = this.userSelectTarget.selectedOptions[0]?.textContent?.trim();
    const currentQcName = this.currentQcTarget.textContent.trim();

    const confirmMessage =
      currentQcUserId && currentQcUserId !== assignedTo
        ? `Transfer QC ownership from ${currentQcName} to ${selectedName}? Existing QC data will be preserved and the new officer can edit the form.`
        : `Assign QC to ${selectedName}?`;

    this.notifications
      .confirm({
        message: confirmMessage,
        confirmButtonText: "Transfer",
        cancelButtonText: "Cancel",
      })
      .then((result) => {
        if (!result.isConfirmed) return;
        this.performReassign(assignedTo);
      });
  }

  performReassign(assignedTo) {
    const body = { assigned_to: assignedTo };
    if (this.hasDueDateTarget && this.dueDateTarget.value) {
      body.due_date = this.dueDateTarget.value;
    }

    fetch(this.reassignUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        Accept: "application/json",
      },
      body: JSON.stringify(body),
    })
      .then((response) =>
        response.json().then((data) => ({
          ok: response.ok,
          data,
        }))
      )
      .then(({ ok, data }) => {
        if (ok) {
          this.close();
          this.notifications.success(data.message || "QC transferred successfully.");
          window.location.reload();
        } else {
          this.notifications.error(data.error || "Failed to transfer QC.");
        }
      })
      .catch(() => {
        this.notifications.error("Failed to transfer QC.");
      });
  }
}
